import React from 'react';
import SVGLoader from './SVGLoader';

const RadiusIcon = props => {
  return (
    <SVGLoader
      {...props}
      width={props.width || 13}
      height={props.height || 25}
      viewboxHeight={11}
      viewboxWidth={10}
    >
      <path
        d="M5,10a5,5,0,1,1,5-5A5.006,5.006,0,0,1,5,10ZM5,1.5A3.5,3.5,0,1,0,8.5,5,3.5,3.5,0,0,0,5,1.5Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0"
      ></path>
      <path
        d="M3.250 5.000 A1.750 1.750 0 1 0 6.750 5.000 A1.750 1.750 0 1 0 3.250 5.000 Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0"
      ></path>
    </SVGLoader>
  );
};

export default RadiusIcon;
